class BlockThreeLinks {

	constructor(){


		let mm = gsap.matchMedia();

		mm.add("(min-width: 992px)", () => {

			let blocks = document.querySelectorAll('.block-three-links');
			let swipers = [];

			blocks.forEach( (block) => {

				let sliderImage = block.querySelector('.slider-image');
				let sliderText = block.querySelector('.slider-text');

				let swiperImage = new Swiper(sliderImage, {
					effect: 'fade',
					speed: 900
				});

				let swiperText = new Swiper(sliderText, {
					speed: 600,
					effect: 'creative',
					creativeEffect: {
						prev: {
							translate: [-20, 0, 0],
							opacity: 0
						},
						next: {
							translate: [-20, 0, 0],
							opacity: 0
						},
					},
				});

				swiperImage.controller.control = swiperText;

				let nav = block.querySelectorAll('.slider-nav a');
				nav.forEach( (el, i) => {

					el.addEventListener('mouseenter', (e) => {

						if( !el.classList.contains('current') ) {
							let current = block.querySelector('.slider-nav a.current');
							current.classList.remove('current');
							let eventLeave = new MouseEvent('customEventLeave');
							current.dispatchEvent(eventLeave);

							setTimeout(() => {
								el.classList.add('current');
								let eventEnter = new MouseEvent('customEventEnter');
								el.dispatchEvent(eventEnter);
							}, 150);

							swiperImage.slideTo(i);
						}

					});

					el.addEventListener('mouseleave', (e) => {
						setTimeout( () => {
							if( !el.classList.contains('current') ){
								let event = new MouseEvent('customEventLeave');
								el.dispatchEvent(event);
							}
						}, 150);
					});

					if( el.classList.contains('current') ) {
						ScrollTrigger.create({
							trigger: el,
							start: "top bottom",
							onEnter: () => {
								let eventInit = new MouseEvent('customEventEnter');
								el.dispatchEvent(eventInit);
							}
						});
					}

				});

				swipers.push(swiperImage);
				swipers.push(swiperText);

			});

			return () => { // optional
				swipers.forEach( (s) => {
					s.destroy();
				});
			};

		});

	}

}
